export const enum Wave {
  Year2025B = 202502,
  Year2025A = 202501,
  Year2024B = 202402,
  Year2024A = 202401,
  Year2023B = 202302,
  Year2023A = 202301,
  Year2022B = 202202,
  Year2022A = 202201,
  Year2021 = 2021,
  Year2020 = 2020
}
